import Box from "@/common/components/Box";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import CreateMaintenanceForwardingHeader from "./CreateMaintenanceForwardingHeader";
import Button from "@/common/components/Button";
import { ArrowLeftIcon } from "lucide-react";
import { useGoBack } from "@/common/hooks/useGoBack";
import { useParams } from "react-router-dom";

interface CreateMaintenanceForwardingDirectiveErrorProps {
  refetchFunction?: VoidFunction;
  statusCode?: number;
  message?: string;
}

const CreateMaintenanceForwardingDirectiveError = ({
  refetchFunction,
  statusCode,
  message,
}: CreateMaintenanceForwardingDirectiveErrorProps) => {
  const { companyId, workflowId } = useParams();

  const goBack = useGoBack();

  return (
    <div className="inner-screen">
      <CreateMaintenanceForwardingHeader />

      <Box className="flex-1 p-0">
        <ErrorMessageWrapper
          statusCode={statusCode}
          refetchFunction={refetchFunction}
          className="h-[calc(100vh-128px)]"
          unknownErrorMessage={message}
          unknownErrorActions={(
            <Button
              variant="neutral"
              className="bg-white-200"
              onClick={() => goBack({
                fallback: `/companies/${companyId}/maintenance/workflows/${workflowId}/forwardings/create`,
                searchLastRouteFromFallback: true,
              })}
            >
              <ArrowLeftIcon size={16} />

              Voltar
            </Button>
          )}
          children
        />
      </Box>
    </div>
  );
}

export default CreateMaintenanceForwardingDirectiveError;
